module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("DetRd"))).then(() => parcelRequire('dJXJK'));